import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

// Extrae a un componente reutilizable el patrón de acordeón que ya se
// usaba inline (copiado a mano) en SGIPanel.jsx: barra de acento a la
// izquierda, ícono opcional, chevron de estado. Controlado desde afuera
// (open/onToggle) para que el padre pueda decidir si permite varias
// secciones abiertas a la vez o solo una.
export function AccordionSection({ id, title, subtitle, icon: Icon, badge, open, onToggle, accentColor = '#2563EB', children }) {
  return (
    <div className={`bg-white rounded-xl border overflow-hidden ${open ? 'border-blue-200 ring-1 ring-blue-100' : 'border-gray-200 hover:border-gray-300'}`}>
      <button
        type="button"
        onClick={() => onToggle(id)}
        className="w-full flex items-center justify-between relative px-4 py-4"
      >
        <div className="absolute left-0 top-0 bottom-0 w-1" style={{ background: accentColor }} />
        <div className="flex items-center gap-3 text-left">
          {Icon ? (
            <div className="w-10 h-10 rounded-xl flex items-center justify-center text-white shadow-sm shrink-0" style={{ background: accentColor }}>
              <Icon size={18} className="text-white" />
            </div>
          ) : null}
          <div>
            <div className="font-semibold flex items-center gap-2">
              {title}
              {badge != null && (
                <span className="text-xs font-normal text-gray-500 bg-gray-100 rounded-full px-2 py-0.5">{badge}</span>
              )}
            </div>
            {subtitle ? <div className="text-gray-600 text-sm">{subtitle}</div> : null}
          </div>
        </div>
        {open ? <ChevronUp className="text-blue-600 shrink-0" size={18} /> : <ChevronDown className="text-gray-500 shrink-0" size={18} />}
      </button>
      {open && (
        <div className="border-t px-4 pb-5 pt-4">
          {children}
        </div>
      )}
    </div>
  );
}

// Envoltorio de conveniencia: renderiza una lista de secciones,
// manejando internamente cuál está abierta (una a la vez).
export function Accordion({ sections, defaultOpenId = null, className = '' }) {
  const [openId, setOpenId] = React.useState(defaultOpenId);
  const toggle = (id) => setOpenId((cur) => (cur === id ? null : id));
  return (
    <div className={`space-y-3 ${className}`}>
      {sections.map((s) => (
        <AccordionSection key={s.id} {...s} open={openId === s.id} onToggle={toggle}>
          {s.content}
        </AccordionSection>
      ))}
    </div>
  );
}

export default Accordion;
